module.exports = __webpack_public_path__ + "static/media/car_overlook.321f4472.svg";